import React, { useState } from "react";
import { Pagamento } from "../../../services/Pagamento";
import { toast } from "react-toastify";
import { FormaPagamentoEnum } from "../../../enums/formaPagamento";
import { useNavigate, useParams } from "react-router-dom";
import { useContextSite } from "../../../context/Context";

export const usePayment = () => {
  const params = useParams();
  const [payment, setPayment] = useState<FormaPagamentoEnum>();
  const [btnFaturaGerada, setBtnFaturaGerada] = useState(false);
  const navigate = useNavigate();
  const { setIsLoad } = useContextSite();

  function handleSubmit(e: React.SyntheticEvent) {
    e.preventDefault();
    setBtnFaturaGerada(true);
    setIsLoad(true);
    Pagamento.gerarFatura({
      uuidAgendamento: params?.uuidAgendamento,
      formaPagamento: payment,
    })
      .then(() =>
        navigate(
          `/agendamento/${
            params?.uuidAgendamento
          }/pagamento/${payment.toLowerCase()}`
        )
      )
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
          setBtnFaturaGerada(false);
        }
      )
      .finally(() => setIsLoad(false));
  }

  return {
    setPayment,
    handleSubmit,
    payment,
    btnFaturaGerada,
    setBtnFaturaGerada,
  };
};
